import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Select from 'antd/lib/select';
import config from '../../../../config';
import { formatMonthsCount, formatMonthsQuantity } from '../../../../common/utils/helpers';

const { Option } = Select;

const Duration = ({ t, value, onChange, minMonths, maxMonths }) => {

  let monthsRange = Array(maxMonths - minMonths + 1).fill().map((_, idx) => minMonths + idx)
  return (
    <Select
      placeholder={t('Vybrať dĺžku splatnosti')}
      onChange={val =>
        onChange({
          termMonthsMin: val,
          termMonthsMax: val,
        })
      }
      value={value}
      className="filter duration-filter"
    >
      <Option value="">{t('Všetky splatnosti')}</Option>
      {monthsRange.map(months => (
        <Option key={`${months}`} value={`${months}`}>
          {formatMonthsCount(months)} {formatMonthsQuantity(months)}
        </Option>
      ))}
    </Select>
  )
};

Duration.propTypes = {
  t: PropTypes.func.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default translate()(Duration);



// WEBPACK FOOTER //
// ./src/features/allocations/components/filters/Duration.js